import { FlowType } from "@redotech/redo-model/return-flow";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatDateTime } from "@redotech/redo-web/time";
import { memo, type ReactNode } from "react";
import * as styles from "./flow-editor-top-header.module.css";
import { FlowVersionHistory } from "./flow-version-history";

interface FlowEditorTopHeaderProps {
  title: string;
  publishedAt: Date | undefined | null;
  buttons: ReactNode;
  flowType: FlowType;
  onReverted?(flow: unknown): void;
}

export const FlowEditorTopHeader = memo(function FlowEditorTopHeader({
  title,
  publishedAt,
  buttons,
  flowType,
  onReverted,
}: FlowEditorTopHeaderProps) {
  const isActive = !!publishedAt;

  return (
    <div className={styles.header}>
      <Flex align="center" justify="space-between" w="full">
        <Flex dir="column" gap="xs">
          <Text fontSize="lg" fontWeight="bold">
            {title}
          </Text>
          <Flex align="center" gap="sm">
            <RedoBadge
              color={isActive ? "success" : "gray"}
              size="xs"
              text={isActive ? "Active" : "Inactive"}
            />
            {publishedAt && (
              <Text color="secondary" fontSize="xs">
                Last published:{" "}
                {formatDateTime(
                  Temporal.Instant.fromEpochMilliseconds(publishedAt.getTime()),
                )}
              </Text>
            )}
          </Flex>
        </Flex>
        <Flex align="center" gap="sm">
          {onReverted && (
            <FlowVersionHistory flowType={flowType} onReverted={onReverted} />
          )}
          {buttons}
        </Flex>
      </Flex>
    </div>
  );
});
